/* ── Studio Phalsa — Navbar JS ───────────────────────────────── */
(function () {
  'use strict';

  function init() {
  const SP_FAV_KEY = 'sp_favourites';

  const navbar = document.getElementById('sp-navbar');
  if (!navbar) return;

  /* ── Scroll: transparent → solid ────────────────────────────── */
  const SCROLL_THRESHOLD = 40;

  function updateScrollState() {
    navbar.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
  }

  window.addEventListener('scroll', updateScrollState, { passive: true });
  updateScrollState(); // run immediately so SSR initial state matches

  /* Pages with no hero (e.g. the product page) have nothing transparent
     to show through, so keep the navbar visually solid from the start.
     This is a separate class from is-scrolled so the wordmark → फ mark
     crossfade still only follows real scroll position, same as every
     other page. */
  const hasHero = document.querySelector('#sp-hero, .sp-hero, [data-sp-hero]');
  if (!hasHero) {
    navbar.classList.add('no-hero');
  }

  /* ── Shop dropdown ───────────────────────────────────────────── */
  const dropdownWraps = navbar.querySelectorAll('[data-sp-dropdown]');

  dropdownWraps.forEach(function (wrap) {
    const btn = wrap.querySelector('[aria-haspopup="true"]');
    if (!btn) return;

    function openDropdown() {
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    /* Desktop: hover intent */
    let hoverTimer;
    wrap.addEventListener('mouseenter', function () {
      clearTimeout(hoverTimer);
      openDropdown();
    });
    wrap.addEventListener('mouseleave', function () {
      hoverTimer = setTimeout(closeDropdown, 80);
    });

    /* Touch / keyboard: toggle on click */
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      wrap.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    /* Keyboard: close on Escape */
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDropdown(); btn.focus(); }
    });
  });

  /* Close all dropdowns on outside click */
  document.addEventListener('click', function () {
    dropdownWraps.forEach(function (wrap) {
      wrap.classList.remove('is-open');
      const btn = wrap.querySelector('[aria-haspopup="true"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── Mobile Drawer ─────────────────────────────────────────────
     Replaces the old .sp-navbar__mobile-menu slide-down panel — this
     is the only hamburger-triggered panel now, so there's no risk of
     two menus opening at once. */
  const mobileDrawer   = document.getElementById('sp-mobile-drawer');
  const drawerBackdrop = document.getElementById('sp-drawer-backdrop');
  const drawerClose    = document.getElementById('sp-drawer-close');
  const hamburgerBtn   = document.getElementById('sp-hamburger');

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.add('is-open');
    if (hamburgerBtn) {
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      hamburgerBtn.setAttribute('aria-label', 'Close menu');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('is-open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('is-open');
    if (hamburgerBtn) {
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      hamburgerBtn.setAttribute('aria-label', 'Open menu');
    }
    document.body.style.overflow = '';
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', openDrawer);
  }

  if (drawerClose) {
    drawerClose.addEventListener('click', closeDrawer);
  }

  if (drawerBackdrop) {
    drawerBackdrop.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeFavDrawer();
    }
  });

  /* Shop accordion in drawer old-code */
  // const shopItem = document.getElementById('sp-drawer-shop');
  // if (shopItem) {
  //   const shopMain = shopItem.querySelector('.sp-mobile-drawer__nav-main');
  //   if (shopMain) {
  //     shopMain.addEventListener('click', function () {
  //       shopItem.classList.toggle('is-open');
  //     });
  //   }
  // }

// new code
/* Mobile drawer: support all dynamic menu accordions */
const drawerNavItems = mobileDrawer
  ? mobileDrawer.querySelectorAll(
      '.sp-mobile-drawer__nav-item--has-sub'
    )
  : [];

drawerNavItems.forEach(function (item) {
  const trigger = item.querySelector('.sp-mobile-drawer__nav-main');
  if (!trigger) return;

  trigger.setAttribute('role', 'button');
  trigger.setAttribute('tabindex', '0');
  trigger.setAttribute('aria-expanded', 'false');

  function toggleSubmenu() {
    const isOpen = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(isOpen));
  }

  trigger.addEventListener('click', toggleSubmenu);

  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleSubmenu();
    }
  });
});
// new code ends

  /* Update favourites count — desktop navbar badge + mobile drawer badge */
  function updateFavCount() {
    const favs  = getFavourites();
    const count = favs.length;

    const desktopBadge = document.getElementById('sp-navbar-fav-badge');
    if (desktopBadge) {
      desktopBadge.textContent = count > 0 ? count : '';
      desktopBadge.classList.toggle('has-items', count > 0);
    }

    const mobileBadge = document.getElementById('sp-fav-count');
    if (mobileBadge) {
      mobileBadge.textContent = count > 0 ? count : '';
      mobileBadge.classList.toggle('has-items', count > 0);
    }
  }
  updateFavCount();

  /* ── Favourites / Wishlist ─────────────────────────────────────── */
  function getFavourites() {
    return JSON.parse(localStorage.getItem(SP_FAV_KEY) || '[]');
  }

  function saveFavourites(favs) {
    localStorage.setItem(SP_FAV_KEY, JSON.stringify(favs));
    updateFavCount();
  }

  function toggleFavourite(productData) {
    const favs = getFavourites();
    const index = favs.findIndex(function (f) { return f.id === productData.id; });

    if (index > -1) {
      favs.splice(index, 1);
    } else {
      favs.push(productData);
    }
    saveFavourites(favs);
    return index === -1;
  }

  function initFavButtons() {
    function attachBtn(btn) {
      if (btn._favInited) return;
      btn._favInited = true;

      const favs = getFavourites();
      const favIds = favs.map(function (f) { return String(f.id); });
      btn.classList.toggle('is-saved', favIds.includes(String(btn.dataset.productId)));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const productData = {
          id: btn.dataset.productId,
          title: btn.dataset.productTitle,
          url: btn.dataset.productUrl,
          price: btn.dataset.productPrice,
          image: btn.dataset.productImage
        };

        const isSaved = toggleFavourite(productData);
        btn.classList.toggle('is-saved', isSaved);

        /* Sync every button for this product (e.g. same product shown
           in both the featured grid and a collection grid) */
        document.querySelectorAll('.sp-fav-btn[data-product-id="' + productData.id + '"]').forEach(function (b) {
          b.classList.toggle('is-saved', isSaved);
        });

        btn.style.transition = 'transform 150ms ease';
        btn.style.transform = 'scale(1.35)';
        setTimeout(function () {
          btn.style.transform = 'scale(1)';
        }, 150);

        renderFavDrawer();
      });
    }

    /* Attach to whatever buttons exist right now */
    document.querySelectorAll('.sp-fav-btn').forEach(attachBtn);

    /* Watch for buttons added later (e.g. a future dynamic section re-render) */
    const favBtnObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('sp-fav-btn')) {
            attachBtn(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.sp-fav-btn').forEach(attachBtn);
          }
        });
      });
    });

    favBtnObserver.observe(document.body, { childList: true, subtree: true });
  }

  initFavButtons();
  updateFavCount();

  /* ── Card reveal — fades the fav heart in with its card ─────────── */
  const revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('[data-sp-reveal], .sp-product-card-wrap, .sp-col-card-wrap').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* ── Favourites Drawer (slides from right, like the cart) ───────── */
  const favDrawer      = document.getElementById('sp-fav-drawer');
  const favBackdrop    = document.getElementById('sp-fav-backdrop');
  const favDrawerClose = document.getElementById('sp-fav-drawer-close');
  const navFavBtn       = document.getElementById('sp-navbar-fav');

  function openFavDrawer() {
    if (!favDrawer) return;
    favDrawer.classList.add('is-open');
    if (favBackdrop) favBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderFavDrawer();
  }

  function closeFavDrawer() {
    if (!favDrawer) return;
    favDrawer.classList.remove('is-open');
    if (favBackdrop) favBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderFavDrawer() {
    const favs = getFavourites();
    const itemsContainer = document.getElementById('sp-fav-drawer-items');
    const emptyState = document.getElementById('sp-fav-drawer-empty');

    if (!itemsContainer) return;

    if (favs.length === 0) {
      itemsContainer.style.display = 'none';
      if (emptyState) emptyState.style.display = 'flex';
      return;
    }

    itemsContainer.style.display = 'flex';
    if (emptyState) emptyState.style.display = 'none';

    itemsContainer.innerHTML = favs.map(function (product) {
      return '' +
        '<div class="sp-fav-item">' +
          '<a href="' + product.url + '" class="sp-fav-item__link" style="display:contents">' +
            '<img class="sp-fav-item__image" src="' + (product.image || '') + '" alt="' + product.title + '" loading="eager">' +
            '<div class="sp-fav-item__info">' +
              '<p class="sp-fav-item__name">' + product.title + '</p>' +
              '<p class="sp-fav-item__price">' + product.price + '</p>' +
            '</div>' +
          '</a>' +
          '<button class="sp-fav-item__remove" data-remove-id="' + product.id + '" aria-label="Remove ' + product.title + '">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<path d="M18 6L6 18M6 6l12 12"/>' +
            '</svg>' +
          '</button>' +
        '</div>';
    }).join('');

    itemsContainer.querySelectorAll('[data-remove-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.dataset.removeId;
        const updated = getFavourites().filter(function (f) { return String(f.id) !== String(id); });
        saveFavourites(updated);

        document.querySelectorAll('.sp-fav-btn[data-product-id="' + id + '"]').forEach(function (b) {
          b.classList.remove('is-saved');
        });

        renderFavDrawer();
      });
    });
  }

  if (navFavBtn) {
    navFavBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openFavDrawer();
    });
  }

  if (favDrawerClose) {
    favDrawerClose.addEventListener('click', closeFavDrawer);
  }

  if (favBackdrop) {
    favBackdrop.addEventListener('click', closeFavDrawer);
  }

  /* Mobile drawer: Favourites row opens the fav drawer instead of
     navigating — closes the hamburger drawer first, then opens the
     fav drawer after the close transition finishes (350ms, matches
     .sp-mobile-drawer's transition duration in sp-navbar.css). */
  const drawerFavBtn = document.getElementById('sp-drawer-favourites');
  if (drawerFavBtn) {
    drawerFavBtn.addEventListener('click', function () {
      closeDrawer();
      setTimeout(function () {
        openFavDrawer();
      }, 350);
    });
  }

  /* ── Cart count badge ────────────────────────────────────────── */
  /* Badge count is Liquid-rendered at page load; kept live below. */
  var cartBadge = navbar.querySelector('.sp-navbar__cart-badge');
  var cartBtn   = navbar.querySelector('.sp-navbar__cart-btn');

  /* ── Open custom cart panel (replaces Horizon's native drawer) ──
     In drawer mode, cart-drawer.js attaches its own on:click="/open"
     listener on <cart-drawer-component> (an ancestor of cartBtn)
     during the CAPTURE phase, so it opens the native drawer before a
     normal bubble-phase listener on cartBtn would even run — calling
     stopPropagation() there is too late. Listening on document with
     capture: true runs first (document is higher up the capture
     chain than cart-drawer-component) and can stop it from ever
     reaching that native handler. This also covers the plain
     `<a href="{{ routes.cart_url }}">` cart link used when
     settings.cart_type isn't 'drawer'. */
  if (cartBtn) {
    document.addEventListener('click', function (e) {
      if (e.target !== cartBtn && !cartBtn.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      if (window.spCartPanel) {
        window.spCartPanel.open();
      }
    }, true);
  }

  /* ── Live cart count via Horizon cart:update event ───────────── */
  /* Horizon fires 'cart:update' on every cart mutation.
     Detail shape: { data: { itemCount } } for product-form additions,
     or { resource: { item_count } } for quantity changes. */
  document.addEventListener('cart:update', function (e) {
    if (!cartBadge) return;
    var count = 0;
    if (e.detail) {
      if (e.detail.data && typeof e.detail.data.itemCount === 'number') {
        count = e.detail.data.itemCount;
      } else if (e.detail.resource && typeof e.detail.resource.item_count === 'number') {
        count = e.detail.resource.item_count;
      }
    }
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? 'flex' : 'none';
    if (cartBtn) {
      cartBtn.setAttribute('aria-label', 'Cart (' + count + ' item' + (count !== 1 ? 's' : '') + ')');
    }
  });

  } // end init

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
